import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import {User} from '../_model/user';
import {EventService} from '../_services/event.service';
import {LookupService} from '../_services/lookup.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.sass'],
  standalone: true,
  imports: [
    CommonModule
  ]
})
export class HomeComponent implements OnInit {

  constructor(private eventService: EventService,
              private lookupService: LookupService) {
  }

  ngOnInit() {
    this.lookupService.listLookups().subscribe(allLookupsResponse => {
      // this.eventService.publishLookupData(allLookupsResponse.responseData.items);
      localStorage.setItem('lookupList', JSON.stringify(allLookupsResponse.responseData.items));
    });
  }

}
